import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { Header } from "@/components/layout/header"
import { FRONTEND_ROUTES } from "@/constants"
import { WhiteLabelProviders } from "@/features/notification-center"

// Tela de Provedores do WL — Central > Configurações > WL > Provedores.
export function NotificationProvidersPage() {
  const { t } = useTranslation()
  const { whiteLabelId } = useParams()

  const links = [
    {
      href: FRONTEND_ROUTES.DASHBOARD.href,
      label: t("sidebar.dashboard"),
    },
    {
      label: t("pages.notificationCenter.title"),
      href: FRONTEND_ROUTES.NOTIFICATION_CENTER.href,
    },
    {
      label: t("pages.notificationCenter.configurations"),
      href: FRONTEND_ROUTES
        .NOTIFICATION_CENTER_CONFIGURATIONS.href,
    },
    {
      label: t(
        "pages.notificationCenter.configurationsDetailPage.breadcrumb"
      ),
      href: `${FRONTEND_ROUTES.NOTIFICATION_CENTER_CONFIGURATIONS.href}/${whiteLabelId}`,
    },
    {
      label: t(
        "pages.notificationCenter.providersPage.breadcrumb"
      ),
    },
  ]
  return (
    <main className="flex w-full flex-1 flex-col">
      <Header>
        <AppBreadcrumb links={links} />
      </Header>
      <section className="flex flex-1 flex-col gap-4 p-4 @container">
        <WhiteLabelProviders />
      </section>
    </main>
  )
}
